import {
  BOOK_APPOINTMENT_REQUEST,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_FAILURE,
  FETCH_APPOINTMENTS_REQUEST,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAILURE,
  CANCEL_APPOINTMENT_REQUEST,
  CANCEL_APPOINTMENT_SUCCESS,
  CANCEL_APPOINTMENT_FAILURE,
  UPDATE_APPOINTMENT_REQUEST,
  UPDATE_APPOINTMENT_SUCCESS,
  UPDATE_APPOINTMENT_FAILURE,
} from "../actions/AppointmentTypes";

const initialState = {
  appointments: [],
  loading: false,
  error: null,
};

export default function AppointmentReducer(state = initialState, action) {
  switch (action.type) {
    case BOOK_APPOINTMENT_REQUEST:
    case FETCH_APPOINTMENTS_REQUEST:
    case CANCEL_APPOINTMENT_REQUEST:
    case UPDATE_APPOINTMENT_REQUEST: 
      return {
        ...state,
        loading: true,
        error: null,
      };

    case BOOK_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: [...state.appointments, action.payload],
        error: null,
      };

      // case FETCH_APPOINTMENTS_SUCCESS:
      //   return {
      //     ...state,
      //     loading: false,
      //     appointments: Array.isArray(action.payload)
      //       ? [
      //           ...(state.appointments || []),
      //           ...action.payload,
      //         ].filter(
      //           (appointment, index, self) =>
      //             index ===
      //             self.findIndex(
      //               (t) => String(t.appointment_id) === String(appointment.appointment_id)
      //             )
      //         )
      //       : state.appointments,
      //     error: null,
      //   };
      
      case FETCH_APPOINTMENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          appointments: Array.isArray(action.payload)
            ? [...action.payload]
            : [],
          error: null,
        };
      
    case CANCEL_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: state.appointments.filter(
          (appointment) => appointment.id !== action.payload
        ),
        error: null,
      };
 
    case UPDATE_APPOINTMENT_SUCCESS: 
      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((appointment) =>
          appointment.id === action.payload.appointment_id
            ? { ...appointment, ...action.payload }
            : appointment
        ),
        error: null,
      };

    case BOOK_APPOINTMENT_FAILURE:
    case FETCH_APPOINTMENTS_FAILURE:
    case CANCEL_APPOINTMENT_FAILURE:
    case UPDATE_APPOINTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
